// MAGIC_DESPROCKET_START
// !!!!!!!!!This file was copied from a gem!!!!!!!!!
// It was originally at: ../rbenv/versions/2.6.3/lib/ruby/gems/2.6.0/gems/rails-assets-kevinwuhoo--trunk8-1.3.5/app/assets/javascripts/trunk8.js

// MAGIC_DESPROCKET_END
//= require trunk8/trunk8.js
// MAGIC_DESPROCKET_START
require('javascripts/former-gems/rails-assets-kevinwuhoo--trunk8-1.3.5/app/assets/javascripts/trunk8/trunk8.js')
// MAGIC_DESPROCKET_END
